import React from "react";
import { BasicSelect, CardShell, FieldLabel } from "./card-handler";

interface BirthdayConditionCardProps {
  config: Record<string, any>;
  onUpdate: (config: Record<string, any>) => void;
  onDelete: () => void;
  onReset: () => void;
  bare?: boolean;
}

export const BirthdayConditionCard: React.FC<BirthdayConditionCardProps> = ({
  config,
  onUpdate,
  onDelete,
  onReset,
  bare,
}) => {
  const updateCondition = (index: number, patch: Record<string, any>) => {
    const conditions = [...(config.conditions ?? [])];
    conditions[index] = { ...(conditions[index] ?? {}), ...patch };
    onUpdate({ ...config, conditions });
  };
  
  const addCondition = () =>
    onUpdate({
      ...config,
      conditions: [
        ...(config.conditions ?? []),
        { variable: "WhatsApp_number", operator: "exists" },
      ],
    });

  const conditions = config.conditions?.length
    ? config.conditions
    : [{ variable: "Birthday_Date", operator: "matches_today" }];

  return (
    <CardShell title="Condition" onDelete={onDelete} onReset={onReset} bare={bare}>
        <div className="space-y-3">
          {conditions.map((condition: any, index: number) => (
            <div key={index} className="rounded-lg bg-indigo-50/70 p-2">
              {index > 0 && (
                <div className="flex items-center gap-2 text-xs text-gray-500 dark:text-gray-400 mb-2">
                  <span className="text-lg leading-none">↳</span>
                  <span className="bg-indigo-100 rounded px-1.5 py-0.5">and</span>
                </div>
              )}
              <FieldLabel>Customer attribute</FieldLabel>
              <input
                value={condition.variable ?? ""}
                onChange={(e) => updateCondition(index, { variable: e.target.value })}
                className="w-full border border-gray-200 dark:border-gray-700 rounded-lg px-3 py-2 text-sm text-indigo-600 outline-none focus:ring-1 focus:ring-indigo-300 mb-2"
              />
              <FieldLabel>Condition</FieldLabel>
              <BasicSelect
                value={condition.operator ?? ""}
                onChange={(value) => updateCondition(index, { operator: value })}
                options={[
                  { label: "matches today", value: "matches_today" },
                  { label: "is before", value: "is_before" },
                  { label: "is after", value: "is_after" },
                  { label: "is on or before", value: "is_on_or_before" },
                  { label: "is on or after", value: "is_on_or_after" },
                  { label: "exists", value: "exists" },
                  { label: "does not exist", value: "does_not_exist" },
                  { label: "True", value: "true" },
                ]}
              />
            </div>
          ))}
        </div>

        <button
          type="button"
          onClick={addCondition}
          className="w-full mt-3 border border-gray-300 dark:border-gray-600 rounded-lg px-3 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800"
        >
          Add Condition
        </button>

        <div className="mt-3 space-y-1.5">
          {["true", "false"].map((branch) => (
            <div key={branch} className="bg-indigo-50 rounded-lg px-3 py-2 text-sm text-center text-gray-700 dark:text-gray-300">
              {branch}
            </div>
          ))}
        </div>
    </CardShell>
  );
};